import { render, staticRenderFns } from "./ResetPasswordFailed.vue?vue&type=template&id=3ea2a191&scoped=true"
import script from "./ResetPasswordFailed.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFailed.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordFailed.vue?vue&type=style&index=0&id=3ea2a191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea2a191",
  null
  
)

export default component.exports